import { createTheme, type CSSVariablesResolver, type MantineColorsTuple } from "@mantine/core";

import { palette } from "./palette";

/** The Mantine theme (light content, the navy sidebar comes from `global.css`). */
export const theme = createTheme({
  colors: { brand: [...palette.brand] as unknown as MantineColorsTuple },
  primaryColor: "brand",
  primaryShade: { light: 7, dark: 5 },
  fontFamily: '"Inter Variable", Inter, "Segoe UI", Roboto, Arial, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", "Cascadia Mono", Consolas, monospace',
  defaultRadius: "md",
  cursorType: "pointer",
  headings: {
    fontFamily: '"Inter Variable", Inter, "Segoe UI", Roboto, Arial, sans-serif',
    fontWeight: "650",
    sizes: {
      h2: { fontSize: "24px", lineHeight: "1.25" },
      h3: { fontSize: "20px", lineHeight: "1.3" },
      h4: { fontSize: "16px", lineHeight: "1.35" },
      h5: { fontSize: "14px", lineHeight: "1.4" },
      h6: { fontSize: "13px", lineHeight: "1.4" },
    },
  },
  shadows: {
    xs: "0 1px 2px rgba(16, 24, 40, 0.05)",
    sm: "0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.04)",
    md: "0 4px 12px rgba(16, 24, 40, 0.08)",
    lg: "0 12px 24px rgba(16, 24, 40, 0.10)",
  },
  components: {
    Card: { defaultProps: { withBorder: true, shadow: "xs", radius: "md", padding: "lg" } },
    Paper: { defaultProps: { radius: "md" } },
    Table: { defaultProps: { verticalSpacing: 8, horizontalSpacing: "md", highlightOnHoverColor: palette.surfaceAlt } },
    Badge: { defaultProps: { variant: "light", radius: "sm" } },
    Tooltip: { defaultProps: { withArrow: true, openDelay: 200 } },
    Drawer: { defaultProps: { overlayProps: { backgroundOpacity: 0.35, blur: 2 } } },
    Modal: { defaultProps: { centered: true, overlayProps: { backgroundOpacity: 0.35, blur: 2 } } },
    SegmentedControl: { defaultProps: { radius: "md" } },
    Notification: { defaultProps: { radius: "md" } },
  },
});

/** The palette as CSS variables (`--sv-*`) for `global.css`. */
export const resolver: CSSVariablesResolver = () => ({
  variables: {
    "--sv-canvas": palette.canvas,
    "--sv-surface": palette.surface,
    "--sv-surface-alt": palette.surfaceAlt,
    "--sv-border": palette.border,
    "--sv-text": palette.text,
    "--sv-muted": palette.muted,
    "--sv-side-bg": palette.side.bg,
    "--sv-side-hover": palette.side.hover,
    "--sv-side-active": palette.side.active,
    "--sv-side-border": palette.side.border,
    "--sv-side-text": palette.side.text,
    "--sv-side-muted": palette.side.muted,
    "--sv-brand": palette.brand[6],
    "--sv-brand-light": palette.brand[3],
    "--sv-scene-top": palette.scene.top,
    "--sv-scene-bottom": palette.scene.bottom,
  },
  light: {},
  dark: {},
});
